// Mock data for Little Splash Swim Program
export const siteInfo = {
  name: 'Little Splash',
  fullName: 'Little Splash Swim Program',
  tagline: 'Confidence Starts Here',
  location: 'Des Moines, IA',
  address: '3003 Woodland Ave, Des Moines, IA 50312',
  email: 'info@littlesplashswimpro.com',
  ownerEmail: 'abrie@littlesplashswimpro.com',
  phone: '515-216-4106',
};

// Winter 2026-27: monthly membership model.
export const winterEnrollment = {
  priorityOpens: '2026-10-23T00:00:00-05:00',
  publicOpens: '2026-10-30T00:00:00-05:00',
  // First monthly release (First Splash calendar + Foundations enrollment).
  firstMonthlyRelease: '2026-11-29',
};

export const winterHours = [
  ['Mon', '9:30 – 10:30 AM | 4:00 – 6:00 PM'],
  ['Tue', 'Closed'],
  ['Wed', '9:30 – 11:00 AM | 4:00 – 6:30 PM'],
  ['Thu', 'Closed'],
  ['Fri', '10:00 – 11:00 AM'],
  ['Sat', '8:30 – 10:30 AM'],
  ['Sun', '9:00 – 11:00 AM'],
];

// Age-based program routes (nav submenu, home + programs overview).
export const programRoutes = [
  { id: 'first-splash', title: 'First Splash', ages: '8 – 12 months', to: '/programs/first-splash', price: '$25', per: '/ session', blurb: 'Parent & Me water introduction. New calendar posted monthly.' },
  { id: 'foundations', title: 'Little Splash Foundations™', ages: '1 – 3 years', to: '/programs/foundations', price: '$60', per: '/ private lesson', blurb: '12-week, 1:1 early water-safety program. 20 private lessons — most graduates are ready for group lessons.' },
  { id: 'membership', title: 'Group Membership', ages: '3 – 12 years', to: '/programs/group-membership', price: 'Monthly', per: 'membership', blurb: 'Max 4 swimmers per class, one class in the pool at a time.' },
  { id: 'private', title: 'Private & Semi-Private', ages: 'All ages', to: '/programs/private-lessons', price: 'Contact', per: 'for availability', blurb: '1:1 or 2:1 lessons with a fully customized plan.' },
];

export const spotsAvailable = true;

// Sibling discount messaging shown on Programs page pricing cards.
export const siblingDiscount = 'Sibling discount — $20 off per additional child';

export const marqueeItems = [
  'INTENTIONAL GROUP SIZES',
  'WATER SAFETY FIRST',
  'PROFESSIONAL INSTRUCTORS',
  'CONFIDENCE BUILDING LESSONS',
  'DES MOINES, IA',
];

export const heroImage =
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/va6pfgqz_IMG_9518.jpeg';

export const aboutHeroImage =
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/1p1hefkz_IMG_9505.jpeg';

export const trustPhotoUrl =
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/gm6e30kl_IMG_9500.jpeg';

export const programsHeroImage =
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/ak9bbbu7_IMG_9507.jpeg';

export const findBestFitHeroImage =
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/h8e8479a_IMG_9508.jpeg';

export const sponsorHeroImage =
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/ak9bbbu7_IMG_9507.jpeg';

export const hopeFloatsVideoUrl =
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/aj7rbelu_Hope%20Floats%20Helps%20Families%21.mp4';

export const givebutterUrl = 'https://givebutter.com/LITTLESPLASHSWIMPROGRAM';

export const issaBadgeSquare =
  'https://customer-assets-jt897jd0.emergentagent.net/job_splash-redesign/artifacts/yihdv7el_V2-ISSA-ACCREDITED-LOGOS-04.png';
export const issaBadgeHorizontal =
  'https://customer-assets-jt897jd0.emergentagent.net/job_splash-redesign/artifacts/iiidwusx_V2-ISSA-ACCREDITED-LOGOS-01.png';

export const promoVideoUrl =
  'https://customer-assets-jt897jd0.emergentagent.net/job_splash-redesign/artifacts/y05bnvya_copy_FBEBB1C4-CA76-4FDD-8AEE-018B97ECFA2E%20%281%29.MOV';

export const calendlyUrl = 'https://calendly.com/littlesplashswim/pre-enrollment';

export const trialCalendlyUrl =
  'https://calendly.com/littlesplashswim/swim-assessment';

export const brandLogo = 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/i3pc7gtq_LS%20LOGS%20-%20Secondary_Landscape%20Logo.png';

export const socialLinks = {
  facebook: 'https://www.facebook.com/profile.php?id=61588202307192',
  instagram: 'https://www.instagram.com/littlesplashswimprogram/',
  instagramHandle: '@littlesplashswimprogram',
  googleReviews: 'https://g.page/r/CQ_MCK-qK0pyEBM/review',
};

export const firstSplashPhotos = {
  hero: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/2bb822c0ac954559_IMG_0084.JPG',
  gallery: [
    { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/fd882964828a4eb8_IMG_0073.JPG', alt: 'Baby reaching for a ball with coach support', pos: 'center 55%' },
    { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/84f63cf09cc4e950_IMG_0070.JPG', alt: 'Smiling toddler in the water with coach', pos: 'center 45%' },
    { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/26b006598f0d4940_IMG_0083.JPG', alt: 'Coach giving a baby a kiss during a lesson', pos: 'center 50%' },
    { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/8fcb343d0a3940ce_IMG_0085.JPG', alt: 'Baby back floating with coach support', pos: 'center 60%' },
  ],
};

export const firstSplashCalendlyUrl =
  'https://calendly.com/littlesplashswim/first-splash-class-calendar?background_color=f8f3e9&text_color=00334a&primary_color=e59a6d';

export const stripePricingTable = {
  id: 'prctbl_1UPqZ8RIc57IyKX29VpY5tEG',
  publishableKey: 'pk_live_51TtAO8RIc57IyKX2Ai14CAmnA0Q4sn51OWFuTz1zBeHdSwI4UAafn5RfMND8V1ZfK730qgbkx1YG3deUzINdeEXy00ZAFAddar',
};

export const coachAbrieBio = {
  intro: "Hi families! I'm Abrie — a certified Water Safety Instructor (WSI) for over 6 years and owner of Little Splash Swim. We're a play-based swim program on a mission to take the fear and overwhelm out of swim lessons and create a positive experience for every little swimmer who comes through our doors.",
  philosophy: "Our curriculum is built around one simple idea: fear isn't a requirement for learning to swim. With a little play, learning becomes fun, engaging, and confidence-building. We use toys, games, and hands-on activities to help children build real water skills while feeling safe, supported, and encouraged — because their feelings matter, too.",
  takeawaysLead: 'When swimmers take lessons with us, they walk away with three things that will change the way you spend summers, vacations, and all the fun pool moments in between:',
  takeaways: [
    { title: 'They know what to do if the worst happens.', body: 'Real water-safety skills, not just swimming skills.' },
    { title: 'A genuine love and respect for the water.', body: 'Plus an understanding of the safety boundaries that keep them smart around it. Say goodbye to tears and unexpected jumps on pool days.' },
    { title: 'An instructor who cares.', body: 'One who listens when they say "I\'m not ready," takes a step back, and makes a plan to get them there.' },
  ],
  emotional: "Because here's the thing: our timelines and feelings aren't the most important — theirs are. Early experiences shape the rest of our lives, and a fear of water is one that sticks.",
  closing: 'Come experience the difference for yourself: heated indoor pool, a maximum of 4 swimmers per class, one class in the pool at a time, and patient instructors who genuinely love what they do. Book your swim assessment today!',
  signature: 'Abrie Freeman',
  title: 'Owner & Lead Instructor',
};

export const gallery = [
  // Newest first — indoor September 2026 shoot
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/va6pfgqz_IMG_9518.jpeg', caption: 'End-of-lesson pride — mission accomplished' },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/j2uqwpf1_IMG_9516.jpeg', caption: 'Kickboard drills, big smiles' },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/o4rdvog2_IMG_9515.jpeg', caption: 'Our quiet indoor pool — where confidence starts', tall: true },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/iov5lx5l_IMG_9514.jpeg', caption: 'Every step out of the water is a small win' },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/wu9n5d74_IMG_9513.jpeg', caption: 'A calm moment in the pool, the world reflected' },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/yad9uc16_IMG_9512.jpeg', caption: 'Sunny swim cap smiles, close and coached' },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/2ozwezhx_IMG_9510.jpeg', caption: 'Coach and two swimmers — teamwork in motion', tall: true },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/h8e8479a_IMG_9508.jpeg', caption: 'Rainbow goggles, focused eyes, brave heart' },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/ak9bbbu7_IMG_9507.jpeg', caption: 'Goggles, kickboard, wall-ready — Little Splash starter kit' },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/ly4arvoh_IMG_9506.jpeg', caption: 'That giggle when the water finally feels like home', tall: true },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/1p1hefkz_IMG_9505.jpeg', caption: 'Guiding a first back float, calm and secure' },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/1tb8a7el_IMG_9503.jpeg', caption: 'Perfect back float — small body, big trust' },
  { src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/gm6e30kl_IMG_9500.jpeg', caption: 'Fish toys and steady hands — one-on-one magic', tall: true },
  // Prior gallery photos
  {
    src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/kaega4i9_391FF906-18F7-4E7F-916A-52F753884E6E.PNG',
    caption: 'First independent back float — arms out, calm and proud',
    tall: true,
  },
  {
    src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/s3nr4adh_BA83B9EC-3CD2-46F8-AAE2-6D3EE18426F5.PNG',
    caption: 'Steady arms, curious eyes — one-on-one at the wall',
  },
  {
    src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/y191pw6o_7CC93E72-E19C-4D13-8191-F707B373D3B6.PNG',
    caption: 'Kickboards, goggles, and the whole class cheering you on',
    tall: true,
  },
  {
    src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/qbhnfjh2_9083DA1A-3F4F-4CC7-8987-AB26091AD9CF.PNG',
    caption: 'Chasing a rubber duckie — the very best kind of practice',
  },
  {
    src: 'https://static.wixstatic.com/media/627438_99da70bc937b40b1b2ee2dbb1ba58418~mv2.jpg/v1/fill/w_1122,h_741,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/AW%20Back%20Float%206-12.jpg',
    caption: 'First float — when "I can\'t" turns into "look at me!"',
    tall: true,
  },
  {
    src: 'https://customer-assets-jt897jd0.emergentagent.net/job_splash-redesign/artifacts/jr1tr4c3_IMG_5099.webp',
    caption: 'Golden hour giggles in the sunlit pool',
  },
  {
    src: 'https://customer-assets-jt897jd0.emergentagent.net/job_splash-redesign/artifacts/kprfugne_AF%20Game%206-12.webp',
    caption: 'Laughter first, lessons second',
  },
  {
    src: 'https://customer-assets-jt897jd0.emergentagent.net/job_splash-redesign/artifacts/8u5wsrot_IMG_5116%202.webp',
    caption: 'Trusting the water, one breath at a time',
    tall: true,
  },
  {
    src: 'https://customer-assets-jt897jd0.emergentagent.net/job_splash-redesign/artifacts/1vil81bj_IMG_5112%202.webp',
    caption: 'Buddy time — shared bravery, shared wins',
  },
  {
    src: 'https://customer-assets-jt897jd0.emergentagent.net/job_splash-redesign/artifacts/fdv4e33d_39307cff-6542-4431-b799-e5ece62604f1.webp',
    caption: 'Playtime is practice in disguise',
  },
  {
    src: 'https://customer-assets-jt897jd0.emergentagent.net/job_splash-redesign/artifacts/c0g4zfi1_IMG_5102%202.webp',
    caption: 'The best kind of tired',
    tall: true,
  },
  {
    src: 'https://static.wixstatic.com/media/627438_9ab156a932d048e49c6936fc58788430~mv2.png/v1/crop/x_319,y_463,w_809,h_611/fill/w_1000,h_756,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Untitled%20design%20(7).png',
    caption: 'Tiny swimmers, big first steps',
    tall: true,
  },
  {
    src: 'https://static.wixstatic.com/media/627438_f2cb96c64364497a8f369621d30cdad8~mv2.png/v1/crop/x_0,y_576,w_977,h_789/fill/w_1000,h_808,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/627438_f2cb96c64364497a8f369621d30cdad8~mv2.png',
    caption: 'One-on-one, right where they need us',
  },
  {
    src: 'https://static.wixstatic.com/media/627438_4fcd2b8233e44495b4a7c57d4e9a1695~mv2.png/v1/crop/x_555,y_328,w_1445,h_1368/fill/w_1000,h_946,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Untitled%20design%20(6).png',
    caption: 'The very first splash — it always sticks',
  },
];

export const approachPillars = [
  {
    title: 'Small, Focused Groups',
    desc: 'Only 4 swimmers per class allows for personalized instruction, individualized feedback, and a calm learning environment where every child receives support and attention.',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/1tb8a7el_IMG_9503.jpeg',
  },
  {
    title: 'Confidence Through Comfort',
    desc: 'We help children build confidence in the water through encouragement, consistency, and a supportive environment designed to help swimmers feel safe and successful.',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/1p1hefkz_IMG_9505.jpeg',
  },
  {
    title: 'Strong Skill Foundations',
    desc: 'Lessons focus on water safety, foundational swim skills, and long-term confidence while helping children progress at a pace that feels comfortable and encouraging.',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/j2uqwpf1_IMG_9516.jpeg',
  },
];

export const programs = [
  {
    id: 'program',
    title: 'Group Membership',
    image:
      'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/ly4arvoh_IMG_9506.jpeg',
    imagePosition: 'center 35%',
    desc: 'Our monthly group membership is designed for swimmers ages 3–12 and focuses on building confidence, comfort, water safety, and real swim skills in a calm, supportive environment.',
    features: [
      'Maximum of 4 swimmers per class',
      'One class in the pool at a time',
      'Personalized instruction and feedback',
      'Great for nervous or beginner swimmers',
    ],
  },
  {
    id: 'private',
    title: 'Private & Semi-Private Classes',
    image:
      'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/1p1hefkz_IMG_9505.jpeg',
    imagePosition: 'center 22%',
    desc: 'Semi-private classes let pairs of siblings or friends build confidence together. Private 1:1 lessons are currently full — join the waitlist and Coach Abrie will reach out the moment a spot opens.',
    features: [
      '2:1 semi-private ratio available now',
      '1:1 private lessons at capacity — waitlist open',
      'Sibling or friend pairs must be within 3 years',
      'Fully customized lesson planning',
    ],
  },
];

export const team = [
  {
    name: 'Coach Khloe',
    role: 'Swim Instructor',
    credentials: 'WSI • Certified in CPR/AED & First Aid',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/be2xkch8_ChatGPT%20Image%20Sep%2012%2C%202026%2C%2011_56_17%20PM.png',
  },
  {
    name: 'Coach Abrie',
    role: 'Owner & Lead Swim Instructor',
    credentials: 'WSI • Certified in CPR/AED & First Aid',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/e908yg0w_ChatGPT%20Image%20Sep%2013%2C%202026%2C%2012_10_35%20AM.png',
    email: 'abrie@littlesplashswimpro.com',
    lead: true,
  },
  {
    name: 'Claire Estoconing',
    role: 'Family Experience Coordinator',
    credentials: 'Licensed Professional Teacher | TEFL Certified',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_c6778eda-94aa-4818-8c0c-4a62c0dfe551/artifacts/60cjo82p_ChatGPT%20Image%20Sep%2013%2C%202026%2C%2012_00_54%20AM.png',
  },
];

export const faqCategories = [
  {
    category: 'Progress',
    items: [
      { q: 'How long will it take my child to learn how to swim?', a: 'Every child learns at their own pace. Progress depends on factors such as age, previous experience, comfort in the water, and lesson attendance. Some children gain confidence quickly, while others need additional time to develop new skills. Our focus is on building strong fundamentals that support long-term success rather than rushing through levels.' },
      { q: 'Will my child move to the next level automatically?', a: 'Children advance when they consistently demonstrate the skills needed for the next level. We want every swimmer to feel confident and successful before moving forward. This helps ensure they build strong, lasting swimming skills rather than simply checking off completed lessons.' },
      { q: 'What if my child learns more slowly?', a: 'That\'s completely okay. Every child develops differently, and we never compare swimmers to one another. Some children need additional practice before mastering a skill, while others progress more quickly. Our instructors adjust lessons to meet each child\'s individual needs while celebrating progress along the way.' },
      { q: 'How do you measure progress?', a: 'Our instructors continuously observe and assess each swimmer\'s skills throughout their lessons. We look at confidence, comfort in the water, skill development, and consistency - not just whether a child can complete a skill once. This helps ensure swimmers are truly ready before moving forward.' },
      { q: 'How often should my child attend lessons?', a: 'Consistency is one of the most important factors in learning to swim. Weekly lessons help children build confidence and reinforce new skills over time. Families looking for faster progress may also benefit from attending more frequently when additional lesson opportunities are available.' },
    ],
  },
  {
    category: 'Getting Started',
    items: [
      { q: 'How do I enroll my child?', a: 'Visit our Programs page and choose the route for your child\'s age — First Splash, Little Splash Foundations™, Group Membership, or Private/Semi-Private. You can also schedule a free pre-enrollment call with our lead instructor to discuss the best fit for your family.' },
      { q: 'Do you offer swim assessments?', a: 'Yes! A 20-minute, one-on-one swim assessment with Coach Abrie is $25 and helps us place your swimmer in the right program. We also offer a free pre-enrollment virtual overview call.' },
    ],
  },
  {
    category: 'Our Teaching Philosophy',
    items: [
      { q: 'What is your teaching approach?', a: 'We take a confidence-first approach, meeting each child where they are without fear or force. We teach water safety alongside age-appropriate swim skills in a calm, encouraging environment.' },
    ],
  },
  {
    category: 'Safety',
    items: [
      { q: 'Are your instructors certified?', a: 'Yes. All Little Splash instructors hold WSI (Water Safety Instructor) certification, Red Cross CPR/AED certification, and engage in frequent training to keep skills sharp and current.' },
      { q: 'How is the pool environment kept safe?', a: 'Only one class swims at a time in our private heated indoor pool, and every class has a maximum of four swimmers to ensure focused supervision at all times.' },
    ],
  },
  {
    category: 'Scheduling',
    items: [
      { q: 'When are classes held?', a: 'Winter 2026–27 hours: Mon 9:30–10:30 AM & 4:00–6:00 PM, Wed 9:30–11:00 AM & 4:00–6:30 PM, Fri 10:00–11:00 AM, Sat 8:30–10:30 AM, Sun 9:00–11:00 AM. Closed Tuesday & Thursday.' },
      { q: 'When does Winter enrollment open?', a: 'Priority enrollment for current and waitlist families opens October 23, 2026. Winter enrollment opens to everyone October 30, 2026.' },
    ],
  },
  {
    category: 'Payment',
    items: [
      { q: 'How does payment work?', a: 'Group lessons (ages 3–12) run as a monthly membership — one subscription per child, with a $20 sibling discount applied after enrollment. Little Splash Foundations™ (ages 1–3) is $60 per private lesson: $240 to start, then $480/month for months 2 and 3. First Splash (8–12 months) is $25 per session.' },
    ],
  },
  {
    category: 'Parent Concerns',
    items: [
      { q: 'What if my child is scared of the water?', a: 'You are not alone — many of our swimmers start out nervous. Our confidence-first approach and calm environment are specifically designed to help children build comfort at their own pace.' },
    ],
  },
];

export const testimonials = [
  {
    name: 'Sarah M.',
    text: 'Coach Abrie is amazing! My son was terrified of the water and now he is jumping in on his own. The small class size makes all the difference.',
    rating: 5,
  },
  {
    name: 'Jessica R.',
    text: 'The best swim program we have tried. The private pool and one-class-at-a-time approach kept our daughter focused and comfortable throughout every lesson.',
    rating: 5,
  },
  {
    name: 'Michael K.',
    text: 'We drive 30 minutes for these lessons and it is worth every mile. My twins have gone from clinging to us to swimming across the pool in just a few months.',
    rating: 5,
  },
];

export const swimGoals = [
  'Build Confidence',
  'Improve Swim Technique',
  'Learn Safety Skills',
  'Develop Swim Strokes',
  'Understand Breath Control',
  'Gain Comfort in the Water',
  'Other',
];

export const classFormats = ['Program Classes', 'Semi-Private', 'Private', 'Other'];
